import { Card, CardBody, Col, Input } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { SelectSizings } from "../../../../Constant";
import { SELECT_FORM_LIST, SIZING_FORM } from "../../../../Data/FormControl/BaseInput";

const SelectSizing = () => {
  return (
    <Col md="6">
      <Card>
        <CommonCardHeader title={SelectSizings} span={SIZING_FORM} />
        <CardBody>
          <Input bsSize="sm" type="select" name="select">
            {SELECT_FORM_LIST.map((item, index) => (
              <option value={index + 1} key={index}>
                {item}
              </option>
            ))}
          </Input>
        </CardBody>
      </Card>
    </Col>
  );
};

export default SelectSizing;
